import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class DeteriorationIndex extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("displayVarLevels", patientNamespace)
  displayVarLevels!: Array<any>;

  get deteriorationIndexVarLevel() {
    return this.displayVarLevels.filter(
      f => f.variable === "DeteriorationIndex"
    )[0].levels;
  }

  get tableColors() {
    return ["", "", "tableGreen", "tableYellow", "tableRed"];
  }

  get tableLabels() {
    return ["", "", "Stable", "Marginal", "Deteriorating"];
  }

  get deteriorationIndexConfig() {
    return {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: 100,
              maxTicksLimit: 10,
              stepSize: 20,
              suggestedMax: 100
            }
          }
        ]
      }
    };
  }

  get charts(): MultiChartConfig[] {
    return [
      {
        data: this.graph(["DeteriorationIndex"]),
        library: this.deteriorationIndexConfig,
        suggestedMax: 100
      }
    ];
  }
  created() {
    this.selectedTime = 24;
  }
}
